import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';



const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';

declare var require: (filename: string) => any;
var BigNumber2100 = require('bignumber.js');

BigNumber2100.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});

const stepsList = [
  /*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['276'] }
];

const tableStructure = [
  { id: 'pagador', title: 'Nombre Pagador' },
  { id: 'origen', title: 'Origen información' },
  { id: 'valor', title: 'Total Ingreso' }
];


class Form1 {
  id: number;
  idSugerida: number;
  origen: string;
  valor: string;
  pagador: string;
  /*  tingreso: string; */
  ingresolabprom: string;
  cesantias: string;
  retencion: string;
  aportesalud: string;
  aporteoblipension: string;
  aportevolpension: string;
  aportesAFCoAVC: string;
  apoyoseconeduca: string;
  cotizavolRAIS: string;

  limitanteAFC: string;
  limitanteRAIS: string;
  limitanteaportevolpension: string;

  limitanteVeinticincoexento: string;
  limitanteCesantiasexento: string;
  controlSugeridaForm: ControlSugeridaForm;
}

class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ingresos-ingresos-asalariado-o-servidor-publico-modal',
  templateUrl: './ingresos-asalariado-o-servidor-publico-modal.component.html',
  styleUrls: ['./ingresos-asalariado-o-servidor-publico-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService

  ]
})
export class IngresosAsalariadooServidorpublicoModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];
  UVT: string;
 // private UVT = "42412"; //año 2023 unidad de valor tributario definida para el año para el cual se declara renta


  rangos = [
    { desde: '0', hasta: '350', tarifa: '1' },
    { desde: '351', hasta: '410', tarifa: '0.90' },
    { desde: '411', hasta: '470', tarifa: '0.80' },
    { desde: '471', hasta: '530', tarifa: '0.60' },
    { desde: '531', hasta: '590', tarifa: '0.40' },
    { desde: '591', hasta: '650', tarifa: '0.20' },

  ];


  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  

  //casillaLimpiada: boolean = false;
  // casillasLimpiadas: { [key: string]: boolean } = {
  //   valor: false,
  //   retencion: false,
  //   aportesalud: false,
  //   aportevolpension: false,
  //   apoyoseconeduca: false,
  //   ingresolabprom: false,
  //   cesantias: false,
  //   aporteoblipension: false,
  //   aportesAFCoAVC: false,
  //   cotizavolRAIS: false
  // };

  saveModel = new EventEmitter();
  public showSave: boolean;
  tablaArt73: any;
  listaActiIng: any;
  model: DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    public dialogRef: MatDialogRef<IngresosAsalariadooServidorpublicoModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();  /* 
    console.log("Este es el modelo: " + this.model) */

  }



  // limpiarValor(campo: string) {
  //   if (this.modelForm[campo] === '0' && !this.casillasLimpiadas[campo]) {
  //     this.modelForm[campo] = null;
  //     this.casillasLimpiadas[campo] = true;
  //   }
  // }

  protected controlStep(direction: DirectionType): void {

  }


  protected operarCamposCuerpo(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {
    let valores = [];
    for (let i in campos) {
      let casilla = modelo.doc.cuerpo[campos[i]] != undefined && modelo.doc.cuerpo[campos[i]] != null ? modelo.doc.cuerpo[campos[i]] : "0";

      //=====
      if (Array.isArray(casilla) && casilla.length === 0) {
        casilla = "0";

        if (this.dutilidades.validarValorNumerico(casilla)) {
          let valor = this.dutilidades.redondearValorMoneda(casilla);
          valores.push(valor);
          //valores.push(modelo.doc.cuerpo[campos[i]]);
        } else {
          valores.push('0');
        }
      }
    }
    return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.idSugerida = 0;
    this.modelForm.origen = "";
    this.modelForm.valor = "0";
    this.modelForm.pagador = "";
    this.modelForm.ingresolabprom = "0";
    this.modelForm.cesantias = "0";
    this.modelForm.retencion = "0";
    this.modelForm.aportesalud = "0";
    this.modelForm.aporteoblipension = "0";
    this.modelForm.aportevolpension = "0";
    this.modelForm.aportesAFCoAVC = "0";
    this.modelForm.apoyoseconeduca = "0";
    this.modelForm.cotizavolRAIS = "0";

    this.modelForm.limitanteAFC = "0";
    this.modelForm.limitanteRAIS = "0";
    this.modelForm.limitanteaportevolpension = "0";

    this.modelForm.limitanteVeinticincoexento = "0";
    this.modelForm.limitanteCesantiasexento = "0";
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_277 == undefined) {
      this.model.doc.cuerpo.cc_id_277 = [];//pagador
      this.model.doc.cuerpo.cc_id_278 = []; //origen
      this.model.doc.cuerpo.cc_id_279 = []; //valor
      this.model.doc.cuerpo.cs_id_280 = "0"; //Total 

      this.model.doc.cuerpo.cc_id_284 = []; //Retención
      this.model.doc.cuerpo.cc_id_285 = []; //Cesantías
      this.model.doc.cuerpo.cc_id_286 = []; //Ingreso Laboral Promedio
      this.model.doc.cuerpo.cc_id_287 = []; //Aporte obligatorio pensión
      this.model.doc.cuerpo.cc_id_288 = []; //Aporte a salud
      this.model.doc.cuerpo.cc_id_289 = []; //Cotizaciones voluntarias – RAIS
      this.model.doc.cuerpo.cc_id_290 = []; //Aportes cuentas AFC O AVC
      this.model.doc.cuerpo.cc_id_291 = []; //Aporte voluntario pensión
      this.model.doc.cuerpo.cc_id_292 = []; //Apoyos económicos educativos

      this.model.doc.cuerpo.cc_id_294 = []; //limitante AFC
      this.model.doc.cuerpo.cc_id_295 = []; //Limitante RAIS
      this.model.doc.cuerpo.cc_id_296 = []; //Limitante aportes voluntarios a fondo pensión

      this.model.doc.cuerpo.cc_id_297 = []; //25% exento
      this.model.doc.cuerpo.cc_id_298 = []; //Cesantías parte exenta
    }
  }


  public operacionCs280(usarModelForm:boolean = false) {

    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma);
    }

    const sumaCc304 = this.obtenerSumaCs304();
    const sumaCc371 = this.obtenerSumaCc371();
    const sumaCc762 = this.obtenerSumaCc762();
  

    const suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, suma, sumaCc304);
    const suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, suma1, sumaCc371);
    const suma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, suma2, sumaCc762);

    this.model.doc.cuerpo.cs_id_280 = suma3;

    this.operacionCc297(usarModelForm);

  }

  protected obtenerSumaCs304() {
    let totalSum = "0";
    if (this.model.doc.cuerpo.cc_id_303 != undefined && this.model.doc.cuerpo.cc_id_303.length > 0) {
      const itemsRentTrabSinCost = this.model.doc.cuerpo.cc_id_303.filter(item => item.v === "1").map(item => item.it);
      const valoresItemsRentTrabSinCost = this.model.doc.cuerpo.cc_id_304.filter(item => itemsRentTrabSinCost.includes(item.it)).map(item => item.v);
      for (let i = 0; i < valoresItemsRentTrabSinCost.length; i++) {
        totalSum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valoresItemsRentTrabSinCost[i], totalSum);
      }
    };
    return totalSum;
  }


  protected obtenerRestaCs711() {
    let totalResta = "0";
    let totalSum1 = "0";
    let totalSum2 = "0";
    let totalSum3 = "0";
    let Totaldepend = "0"

    let totaldependientes = "0";
    let sumdepen = "0";

    let f: number = 0;

    if (this.model.doc.cuerpo.cc_id_711 != undefined && this.model.doc.cuerpo.cc_id_711.length > 0) {


      for (let i = 0; i < this.model.doc.cuerpo.cc_id_711.length; i++) {
        if (this.model.doc.cuerpo.cc_id_711[i].v == "1") {
          totalSum1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_713[i].v, totalSum1);
        } else if (this.model.doc.cuerpo.cc_id_711[i].v == "3") {
          totalSum2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_713[i].v, totalSum2);
        } else if (this.model.doc.cuerpo.cc_id_711[i].v == "6" && this.model.doc.cuerpo.cc_id_712[i].v == "1") {
          totalSum3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_713[i].v, totalSum3);
          sumdepen = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_280, this.model.doc.cuerpo.cs_id_305);
          //totaldependientes = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, this.model.doc.cuerpo.cs_id_280, sumdepen, false);
          let sumaCan = "0";
          if(this.model.doc.cuerpo.cc_id_760.length)
            for (let i = 0; i < this.model.doc.cuerpo.cc_id_760.length; i++) 
            {
              if( Number(this.model.doc.cuerpo.cc_id_760[i].v)===11 && Number(this.model.doc.cuerpo.cc_id_761[i].v)===2)
              {
                sumaCan = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, sumaCan, this.model.doc.cuerpo.cc_id_762[i].v);
              }
            }
          sumdepen = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, sumdepen, sumaCan);
        
          // Totaldepend = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, totalSum3, totaldependientes);

          if (this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MAYOR_QUE, sumdepen, "0", false)) {
            f = Number(this.model.doc.cuerpo.cs_id_280) / Number(sumdepen);
            let f6: string = f.toFixed(7);
            Totaldepend = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, totalSum3, f6);
            Totaldepend = this.dutilidades.redondearValorMoneda(Totaldepend);
          } else {
            Totaldepend = "0";
          }
        }
      }

    };

    totalResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, totalSum1, totalSum2);
    totalResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, totalResta, Totaldepend);


    return totalResta;
  }

  protected obtenerSumaCs290() {
    let suma290 = "0";
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_290.length; i++) {
      suma290 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cc_id_290[i].v, suma290);
    }

    this.modelForm.aportesAFCoAVC = suma290;

    //return totalSum;
  }

  protected obtenerSumaCc371() {
    let totalSum = "0";
    if (this.model.doc.cuerpo.cc_id_370 != undefined && this.model.doc.cuerpo.cc_id_370.length > 0) {
      const items370 = this.model.doc.cuerpo.cc_id_370.filter(item => item.v == "1").map(item => item.it);
      const valoresitems370 = this.model.doc.cuerpo.cc_id_371.filter(item => items370.includes(item.it)).map(item => item.v);
      for (let i = 0; i < valoresitems370.length; i++) {
        totalSum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valoresitems370[i], totalSum);
      }
    };
    return totalSum;
  }

  protected obtenerSumaCc624() {
    let totalSum = "0";
    if (this.model.doc.cuerpo.cc_id_623 != undefined && this.model.doc.cuerpo.cc_id_623.length > 0) {
      const items623 = this.model.doc.cuerpo.cc_id_623.filter(item => item.v == "3" || item.v == "4").map(item => item.it);
      // const valores625 = this.model.doc.cuerpo.cc_id_625.filter(item => items623.includes(item.it)).map(item => item.v);
      // for (let i = 0; i < valores625.length; i++) {
      //   totalSum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valores625[i], totalSum);
      // }
      //CAMBIO CASILLA DE 625 A 624
      const valores624 = this.model.doc.cuerpo.cc_id_624.filter(item => items623.includes(item.it)).map(item => item.v);
      for (let i = 0; i < valores624.length; i++) {
        totalSum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valores624[i], totalSum);
      }
    };
    return totalSum;
  }

  // //========= Validaciones Casillas Ocultas=============//

  //Función para ser llamada desde otros modales que actualiza limitantes AFC, RAIS y AportePension
  public operacionesLimitantesComunes() {
    if (this.model.doc.cuerpo.cc_id_294[0]) {
      this.operacionesLimitantesComunesPorCasilla("0.30", "3800", "limitanteAFC");
      this.operacionesLimitantesComunesPorCasilla("0.25", "2500", "limitanteRAIS");
      this.operacionesLimitantesComunesPorCasilla("0.30", "3800", "limitanteaportevolpension");
      this.model.doc.cuerpo.cc_id_294[0].v = this.modelForm.limitanteAFC.toString();
      this.model.doc.cuerpo.cc_id_295[0].v = this.modelForm.limitanteRAIS.toString();
      this.model.doc.cuerpo.cc_id_296[0].v = this.modelForm.limitanteaportevolpension.toString();
    }

    // console.log("Valor 294 :" + this.model.doc.cuerpo.cc_id_294[0].v)
    // console.log("Valor 295 :" + this.model.doc.cuerpo.cc_id_295[0].v)
    // console.log("Valor 296 :" + this.model.doc.cuerpo.cc_id_296[0].v)
  }

  public operacionesLimitantesComunesPorCasilla(factorMulti: string, topeMaxUVT: string, campoLimitanteModelForm: string) {

    let resSuma = "0";

    //if (((this.model.doc.cuerpo.cc_id_303 != undefined || this.model.doc.cuerpo.cc_id_303.length > 0) || this.model.doc.cuerpo.cc_id_303 == 1) && (this.model.doc.cuerpo.cs_id_280 != undefined || this.model.doc.cuerpo.cs_id_280.length > 0)) {
    if (this.model.doc.cuerpo.cs_id_280 != undefined && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_280, '0')) {
      let cs305 = this.model.doc.cuerpo.cs_id_305 != undefined && this.model.doc.cuerpo.cs_id_305 != null ? this.model.doc.cuerpo.cs_id_305 : "0";
      let cs372 = this.model.doc.cuerpo.cs_id_372 != undefined && this.model.doc.cuerpo.cs_id_372 != null ? this.model.doc.cuerpo.cs_id_372 : "0";
      let cs328 = this.model.doc.cuerpo.cs_id_328 != undefined && this.model.doc.cuerpo.cs_id_328 != null ? this.model.doc.cuerpo.cs_id_328 : "0";
      let cs343 = this.model.doc.cuerpo.cs_id_343 != undefined && this.model.doc.cuerpo.cs_id_343 != null ? this.model.doc.cuerpo.cs_id_343 : "0";
      let cs355 = this.model.doc.cuerpo.cs_id_355 != undefined && this.model.doc.cuerpo.cs_id_355 != null ? this.model.doc.cuerpo.cs_id_355 : "0";
      let cs494 = this.model.doc.cuerpo.cs_id_494 != undefined && this.model.doc.cuerpo.cs_id_494 != null ? this.model.doc.cuerpo.cs_id_494 : "0";
      let cs509 = this.model.doc.cuerpo.cc_id_509[0] != undefined && this.model.doc.cuerpo.cc_id_509[0] != null ? this.model.doc.cuerpo.cc_id_509[0].v : "0";
      let cs539 = this.model.doc.cuerpo.cs_id_539 != undefined && this.model.doc.cuerpo.cs_id_539 != null ? this.model.doc.cuerpo.cs_id_539 : "0";
      let cs568 = this.model.doc.cuerpo.cs_id_568 != undefined && this.model.doc.cuerpo.cs_id_568 != null ? this.model.doc.cuerpo.cs_id_568 : "0";
      let cs586 = this.model.doc.cuerpo.cs_id_586 != undefined && this.model.doc.cuerpo.cs_id_586 != null ? this.model.doc.cuerpo.cs_id_586 : "0";
      let cs608 = this.model.doc.cuerpo.cs_id_608 != undefined && this.model.doc.cuerpo.cs_id_608 != null ? this.model.doc.cuerpo.cs_id_608 : "0";
      let cs626 = this.model.doc.cuerpo.cs_id_626 != undefined && this.model.doc.cuerpo.cs_id_626 != null ? this.model.doc.cuerpo.cs_id_626 : "0";
      let cs648 = this.model.doc.cuerpo.cs_id_648 != undefined && this.model.doc.cuerpo.cs_id_648 != null ? this.model.doc.cuerpo.cs_id_648 : "0";
      let cs763 = this.model.doc.cuerpo.cs_id_763 != undefined && this.model.doc.cuerpo.cs_id_763 != null ? this.model.doc.cuerpo.cs_id_763 : "0";
      //const sumaCc625 = this.obtenerSumaCc265();
      //Cambio casilla de 625 a 624
      const sumaCc624 = this.obtenerSumaCc624();

      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_280, cs305, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs372, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs328, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs343, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs355, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs494, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs509, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs539, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs568, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs586, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs608, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs626, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs648, true);
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, cs763, true);
      //resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, sumaCc625, true); 
      //Cambio casilla de 625 a 624
      resSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resSuma, sumaCc624, true);

      const resultadoMultFactor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resSuma, factorMulti, true);
      const resultadoMultFactorUVT = this.convertirPesosUvt(resultadoMultFactor, 'resultadoMultFactor');

      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, resultadoMultFactorUVT, topeMaxUVT)) {
        this.modelForm[campoLimitanteModelForm] = resultadoMultFactor;
      } else {
        this.modelForm[campoLimitanteModelForm] = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, topeMaxUVT, this.UVT, true);
      }

    } else {
      this.modelForm[campoLimitanteModelForm] = "0";
    }
  }

  protected obtenerRestaCc762() {
    let cas762T = '0';
    if (this.model.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model.doc.cuerpo.cc_id_760.length; i++) {
        if (Number(this.model.doc.cuerpo.cc_id_761[i].v) === 1 &&
          (Number(this.model.doc.cuerpo.cc_id_760[i].v) === 1 ||

            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 11 ||
            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 2 ||
            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 3 ||
            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 4 ||
            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 5 ||
            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 6 ||
            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 7 ||
            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 8 ||
            Number(this.model.doc.cuerpo.cc_id_760[i].v) === 9)) {
          cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model.doc.cuerpo.cc_id_762[i].v);
        }
      }
    return cas762T;
  }


  protected obtenerSumaCc762() {
    let cas762s = '0';
    if (this.model.doc.cuerpo.cc_id_761.length)
     
      for (let i = 0; i < this.model.doc.cuerpo.cc_id_761.length; i++) {
        if (Number(this.model.doc.cuerpo.cc_id_761[i].v) === 1 ) {
        //1,2,3,4,5,6,7,10
        if (Number(this.model.doc.cuerpo.cc_id_760[i].v) === 8
          || Number(this.model.doc.cuerpo.cc_id_760[i].v) === 9
          || Number(this.model.doc.cuerpo.cc_id_760[i].v) === 11) {
          cas762s = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762s, this.model.doc.cuerpo.cc_id_762[i].v);
        }
      }
    }
    return cas762s;
  }


  protected obtenerRestaCc699() {
    let cas699 = '0';
    if (this.model.doc.cuerpo.cc_id_699.length)
      for (let i = 0; i < this.model.doc.cuerpo.cc_id_699.length; i++) {
        if ((Number(this.model.doc.cuerpo.cc_id_697[i].v) === 1) ||
          (Number(this.model.doc.cuerpo.cc_id_697[i].v) === 2) ||
          (Number(this.model.doc.cuerpo.cc_id_697[i].v) === 3)
        ) {
          cas699 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas699, this.model.doc.cuerpo.cc_id_699[i].v);
        }
      }
    return cas699;
  }

  public operacionCc297(usarModelForm:boolean = false) {

    //SI 280 > 0  O CAS 303 = 1 (Cas 280 - Cas 285 - Cas 287 - Cas 288 - Cas 289 - Cas 291) * 0,25 <=  9480 UVT anual

    const topeMax790uvt = "790"; //Equivale 

    let resultResta = "0";
    const sumaCc304 = this.obtenerSumaCs304();
    const restaCc711 = this.obtenerRestaCs711();
    const restaCc762 = this.obtenerRestaCc762();
    const restaCC699 = this.obtenerRestaCc699();
    const sumaCC762 = this.obtenerSumaCc762();

    this.operacionCc298(usarModelForm);
    let val285 = "0";
    const valorCesantias = this.modelForm.cesantias !='0'? this.modelForm.cesantias : this.getValueCas('cc_id_285');
    const limitantesCesantias =this.modelForm.limitanteCesantiasexento !='0' ? this.modelForm.limitanteCesantiasexento:this.getValueCas('cc_id_298');
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, valorCesantias, limitantesCesantias)) {
      val285 =valorCesantias;
    } else {
      val285 = limitantesCesantias;
    }

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, sumaCc304, '0') || //304>0 significa que 303=1
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valor, '0') ||
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, sumaCC762, '0') ||
      (this.model.doc.cuerpo.cs_id_280 != undefined && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_280, '0'))
    ) {
      //resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_280, sumaCC762, true);
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_280, "0", true);
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, val285, true);

      const apoyoseconeduca = !usarModelForm ? this.getValueCas('cc_id_292') : this.modelForm.apoyoseconeduca;
      const aporteoblipension = !usarModelForm ?  this.getValueCas('cc_id_287') : this.modelForm.aporteoblipension;
      const aportesalud = !usarModelForm ? this.getValueCas('cc_id_288') : this.modelForm.aportesalud;

      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, apoyoseconeduca, true);
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, aporteoblipension, true);
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, aportesalud, true);
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, this.model.doc.cuerpo.cs_id_676, true);
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, this.model.doc.cuerpo.cs_id_702, true);
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, restaCc711, true);
      /*     resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, sumaCC762, true); */
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, restaCc762, true);
      resultResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultResta, restaCC699, true);

      //  let resultadoCampos297 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultado297, '0.25', true);

      let mayorque = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultResta, '0');
      if (mayorque) {
        let resMult = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultResta, '0.25', true);
        let resMultUVT = this.convertirPesosUvt(resMult, 'resultadoCampos');

        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, resMultUVT, topeMax790uvt)) {
          this.modelForm.limitanteVeinticincoexento = resMult;
        }
        else {
          this.modelForm.limitanteVeinticincoexento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, topeMax790uvt, this.UVT, true);
        }
      } else {
        this.modelForm.limitanteVeinticincoexento = "0";
      }
    }

    console.log("casilla 297" + this.modelForm.limitanteVeinticincoexento)
    if (this.model.doc.cuerpo.cc_id_297[0] == undefined) {
      this.model.doc.cuerpo.cc_id_297[0] = {};
    }
    this.model.doc.cuerpo.cc_id_297[0].it = 1;
    this.model.doc.cuerpo.cc_id_297[0].v = this.dutilidades.deshacerFormatoMoneda(this.modelForm.limitanteVeinticincoexento);
  }


  // cas493T='0';
  //       c



  public operacionCc298(usarModelForm:boolean = false) {

    const sumaCc304 = this.obtenerSumaCs304();


    //  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, sumaCc304, '0') || //304>0 significa que 303=1
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valor, '0') ||
      (this.model.doc.cuerpo.cs_id_280 != undefined && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_280, '0'))) {
      const topeMaxUVT = "350";

      const cesantias = !usarModelForm ? this.getValueCas('cc_id_285') || this.modelForm.cesantias : this.modelForm.cesantias;
      const ingresolabprom = !usarModelForm ? this.getValueCas('cc_id_286') || this.modelForm.ingresolabprom: this.modelForm.ingresolabprom;

      let cas286UVT = this.convertirPesosUvt(ingresolabprom, 'cas286');
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas286UVT, topeMaxUVT)) {
        this.modelForm.limitanteCesantiasexento = cesantias
      } else
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas286UVT, topeMaxUVT)) {
          let rangouvt = this.obtenerTarifa(cas286UVT);
          this.modelForm.limitanteCesantiasexento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cesantias, rangouvt.toString());
        }
    }

    this.redondearFormData();
  }

  public obtenerTarifa(valorAsignado: string): string {
    let tarifaResultante = '';
    const topeMaxUVT1 = "650";

    // Iterar sobre el array y encontrar la tarifa adecuada
    for (let i = 0; i < this.rangos.length; i++) {
      let rangoDesde = this.rangos[i].desde;
      let rangoHasta = this.rangos[i].hasta;

      // Verificar si el valor está dentro del rango
      //if (valorAsignado >= rangoDesde && vvalorAsignadoalor <= rangoHasta) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, valorAsignado, rangoDesde) &&
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorAsignado, rangoHasta)) {
        return this.rangos[i].tarifa;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, valorAsignado, topeMaxUVT1)) {
        return '0';//Si sobrepasa los límites de la tabla entonces retorna 0
      }
    }
    return tarifaResultante;
  }

  public convertirPesosUvt(valorPesos = "0", origen) { //SE AGREGO EL IGUAL A 0

    // Verificar si valorPesos es un array
    if (Array.isArray(valorPesos)) {
      // Si es un array, no hacer nada y retornar
      /* console.log(`El valor de array proviene de: ${origen}`); */
      return;
    }

    valorPesos = String(valorPesos);
    let valorOperacion = new BigNumber2100(this.dutilidades.deshacerFormatoMoneda(valorPesos));
    // let valorOperacion = new BigNumber2100((valorPesos));
    valorOperacion = valorOperacion.div(this.UVT);
    valorOperacion = valorOperacion.toFormat();
    valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }


  //========= Fin Validaciones Casillas Ocultas=============//

  protected initializeTablaDesdeModelo() {

    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_277.length; i++) {
      if (this.model.doc.cuerpo.cc_id_277[i]) {
        this.modelForm.id = i;
        this.modelForm.pagador = this.model.doc.cuerpo.cc_id_277[i].v;
        this.modelForm.origen = this.model.doc.cuerpo.cc_id_278[i].v;
        this.modelForm.valor = this.model.doc.cuerpo.cc_id_279[i].v;
        this.modelForm.retencion = this.model.doc.cuerpo.cc_id_284[i].v;
        this.modelForm.cesantias = this.model.doc.cuerpo.cc_id_285[i].v;
        this.modelForm.ingresolabprom = this.model.doc.cuerpo.cc_id_286[i].v;
        this.modelForm.aporteoblipension = this.model.doc.cuerpo.cc_id_287[i].v;
        this.modelForm.aportesalud = this.model.doc.cuerpo.cc_id_288[i].v;
        this.modelForm.cotizavolRAIS = this.model.doc.cuerpo.cc_id_289[i].v;
        this.modelForm.aportesAFCoAVC = this.model.doc.cuerpo.cc_id_290[i].v;
        this.modelForm.aportevolpension = this.model.doc.cuerpo.cc_id_291[i].v;
        this.modelForm.apoyoseconeduca = this.model.doc.cuerpo.cc_id_292[i].v;

        this.modelForm.limitanteAFC = this.model.doc.cuerpo.cc_id_294[i].v;
        this.modelForm.limitanteRAIS = this.model.doc.cuerpo.cc_id_295[i].v;
        this.modelForm.limitanteaportevolpension = this.model.doc.cuerpo.cc_id_296[i].v;

        this.modelForm.limitanteVeinticincoexento = this.model.doc.cuerpo.cc_id_297[i].v;
        this.modelForm.limitanteCesantiasexento = this.model.doc.cuerpo.cc_id_298[i].v;

        this.dataSourceBody.push(this.modelForm);
        this.inicializeForm();
      }
    }
    this.operacionCs280();

  }

  protected initializeTablaDesdeSugerida() {
    let indexModel = this.model.doc.cuerpo.cc_id_277.length;

    if (indexModel == 0) {
      const fieldsRecovery = ['VAR_4044','VAR_4053','VAR_4216','VAR_4048','VAR_4049','VAR_4050','VAR_3132','VAR_4214','VAR_4052','VAR_4217','VAR_4218','VAR_4219','VAR_4215','VAR_4057','VAR_4217','VAR_4218','VAR_4219','VAR_4225','VAR_4221','VAR_3136','VAR_4222','VAR_4058','VAR_4213','VAR_4056','VAR_4214'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      const grupos=[
        ['VAR_4044','VAR_4053','VAR_4216','VAR_4048','VAR_4049','VAR_4050','VAR_3132','VAR_4214','VAR_4052','VAR_4217','VAR_4218','VAR_4219','VAR_4215'],
        ['VAR_4057'],
        ['VAR_4217','VAR_4218','VAR_4219'],
        ['VAR_4225'],
        ['VAR_4221'],
        ['VAR_3136'],
        ['VAR_4222'],
        ['VAR_4058','VAR_4213'],
        ['VAR_4056'],
        ['VAR_4214']
      ];

      if (resData) {
        let mapIndexReportante = new Map(); //Si se esperan VARIABLES para diferentes campos 
                                              //se deben actualizar para el mismo Nit reportante en lugar de crear un nuevo registro.
                                              //Estructura del map (es un map anidado en otro map): 
                                              //  [numNitInformante, [j, this.modelForm.id] ]
        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {
            this.modelForm.id = indexModel;
            this.modelForm.pagador = resData[i].item.numNitInformante[j] + "/" + resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.origen = "0";
            
            
              //NOTA: La implementación de la lógica tiene variaciones en relación a las otras tarjetas que usan 'GRUPOS' para el control de sugerida
              let itemGrupoFormPorEditar:Form1 = null;

              //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
              let idGrupo:number = -1;
              for(let k=0;k<grupos.length;k++){
                if(grupos[k].includes(resData[i].key)){
                  idGrupo=k;
                  break;
                }
              }

              //1. El nit ya existe? NO ->1:Agregar
              if(this.dataSourceBody.find((el)=>{
                return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
              })==undefined){
                itemGrupoFormPorEditar = null;
              }else{

                //2. Trae array de solo los del NIT
                let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                  if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                    return el;
                  }
                });

                //3. Recorrer array de solo los del NIT
                for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                  //En el registro existe una variable del GRUPO?  (CAMBIO DE LÓGICA CON RESPECTO A LAS DEMÁS TARJETAS)
                  //  - SI: Debe Editar el registro y deja de buscar
                  //  - NO: Siga buscando (al final no existe entonces debe Agregar nuevo registro)
                  let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                  if((dataGrupo || (idGrupo!=0 && idGrupo!=2 && idGrupo!=7) ) ){
                    itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                    break;
                  }
                }

              }
              
              //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
              if(itemGrupoFormPorEditar){
                this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                  if(itemModelForm.id == itemGrupoFormPorEditar.id){
                    itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                    itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]),resData[i].key);
                  }
                  return itemModelForm;
                });
              }else{
                this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
                this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
                this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
                this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                this.redondearFormData();
                this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]),resData[i].key);
                this.dataSourceBody.push(this.modelForm);
                this.inicializeForm();
                indexModel++;
              }
            

          }
        }

        //Si en la operación 'asignarVariablesSugeridasCondicionadas' el 'valor' queda negativa o 0 entonces se elimina.
        this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
          if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, itemModelForm.valor, "0")){
            return itemModelForm;
          }
        });

      }
    }
    this.operacionCs280();

  }

  private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string, variable:string){

    if(variable=='VAR_4044' || variable=='VAR_4053' || variable=='VAR_4216' || variable=='VAR_4048' || variable=='VAR_4049' || variable=='VAR_4050' || variable=='VAR_3132' || variable=='VAR_4214' || variable=='VAR_4052' || variable=='VAR_4217' || variable=='VAR_4218' || variable=='VAR_4219' || variable=='VAR_4215')//valor=VAR_4044+VAR_4053+VAR_4216+VAR_4048+VAR_4049+VAR_4050+VAR_3132+VAR_4214+VAR_4052+VAR_4217+VAR_4218+VAR_4219+VAR_4215
      itemModelForm.valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, itemModelForm.valor, valor);
    if(variable=='VAR_4057')
      itemModelForm.retencion=String(valor);
    if(variable=='VAR_4217' || variable=='VAR_4218' || variable=='VAR_4219' )//cesantias=VAR_4217 O VAR_4218 O VAR_4219 (tomar la mayor)
      itemModelForm.cesantias=this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, itemModelForm.cesantias)?valor:itemModelForm.cesantias;
    if(variable=='VAR_4225')
      itemModelForm.ingresolabprom=String(valor);
    if(variable=='VAR_4221')
      itemModelForm.aporteoblipension=String(valor);
    if(variable=='VAR_3136')
      itemModelForm.aportesalud=String(valor);
    if(variable=='VAR_4222')
      itemModelForm.cotizavolRAIS=String(valor);
    if(variable=='VAR_4058' || variable=='VAR_4213')//AFC=VAR_4058 + VAR_4213
      itemModelForm.aportesAFCoAVC=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, itemModelForm.aportesAFCoAVC, valor);
    if(variable=='VAR_4056')
      itemModelForm.aportevolpension=String(valor);
    if(variable=='VAR_4214')
      itemModelForm.apoyoseconeduca=String(valor);
    
    return itemModelForm;
  }



  public editModeloDesdeForm() {

    this.model.doc.cuerpo.cc_id_277[this.modelForm.id].v = this.modelForm.pagador;
    this.model.doc.cuerpo.cc_id_278[this.modelForm.id].v = this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_279[this.modelForm.id].v = this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_286[this.modelForm.id].v = this.modelForm.ingresolabprom.toString(); //Ingreso Laboral Promedio
    this.model.doc.cuerpo.cc_id_284[this.modelForm.id].v = this.modelForm.retencion.toString(); //Retención
    this.model.doc.cuerpo.cc_id_285[this.modelForm.id].v = this.modelForm.cesantias.toString(); //Cesantías
    this.model.doc.cuerpo.cc_id_288[this.modelForm.id].v = this.modelForm.aportesalud.toString(); //Aporte a salud
    this.model.doc.cuerpo.cc_id_287[this.modelForm.id].v = this.modelForm.aporteoblipension.toString(); //Aporte obligatorio pensión
    this.model.doc.cuerpo.cc_id_291[this.modelForm.id].v = this.modelForm.aportevolpension.toString(); //Aporte voluntario pensión
    this.model.doc.cuerpo.cc_id_290[this.modelForm.id].v = this.modelForm.aportesAFCoAVC.toString(); //Aportes cuentas AFC O AVC
    this.model.doc.cuerpo.cc_id_292[this.modelForm.id].v = this.modelForm.apoyoseconeduca.toString(); //Apoyos económicos educativos
    this.model.doc.cuerpo.cc_id_289[this.modelForm.id].v = this.modelForm.cotizavolRAIS.toString(); //Cotizaciones voluntarias – RAIS

    this.model.doc.cuerpo.cc_id_294[this.modelForm.id].v = this.modelForm.limitanteAFC.toString();
    this.model.doc.cuerpo.cc_id_295[this.modelForm.id].v = this.modelForm.limitanteRAIS.toString();
    this.model.doc.cuerpo.cc_id_296[this.modelForm.id].v = this.modelForm.limitanteaportevolpension.toString();

    this.model.doc.cuerpo.cc_id_297[this.modelForm.id].v = this.modelForm.limitanteVeinticincoexento.toString();
    this.model.doc.cuerpo.cc_id_298[this.modelForm.id].v = this.modelForm.limitanteCesantiasexento.toString();

    this.operacionCs280();
  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_277.push({ it: i, v: this.modelForm.pagador });
    this.model.doc.cuerpo.cc_id_278.push({ it: i, v: this.modelForm.origen });
    this.model.doc.cuerpo.cc_id_279.push({ it: i, v: this.modelForm.valor.toString() });

    this.model.doc.cuerpo.cc_id_284.push({ it: i, v: this.modelForm.retencion.toString() }); //Retención
    this.model.doc.cuerpo.cc_id_285.push({ it: i, v: this.modelForm.cesantias.toString() }); //Cesantías
    this.model.doc.cuerpo.cc_id_286.push({ it: i, v: this.modelForm.ingresolabprom.toString() }); //Ingreso Laboral Promedio
    this.model.doc.cuerpo.cc_id_287.push({ it: i, v: this.modelForm.aporteoblipension.toString() }); //Aporte obligatorio pensión
    this.model.doc.cuerpo.cc_id_288.push({ it: i, v: this.modelForm.aportesalud.toString() }); //Aporte a salud
    this.model.doc.cuerpo.cc_id_289.push({ it: i, v: this.modelForm.cotizavolRAIS.toString() }); //Cotizaciones voluntarias – RAIS
    this.model.doc.cuerpo.cc_id_290.push({ it: i, v: this.modelForm.aportesAFCoAVC.toString() }); //Aportes cuentas AFC O AVC
    this.model.doc.cuerpo.cc_id_291.push({ it: i, v: this.modelForm.aportevolpension.toString() }); //Aporte voluntario pensión
    this.model.doc.cuerpo.cc_id_292.push({ it: i, v: this.modelForm.apoyoseconeduca.toString() }); //Apoyos económicos educativos

    this.model.doc.cuerpo.cc_id_294.push({ it: i, v: this.modelForm.limitanteAFC.toString() });
    this.model.doc.cuerpo.cc_id_295.push({ it: i, v: this.modelForm.limitanteRAIS.toString() });
    this.model.doc.cuerpo.cc_id_296.push({ it: i, v: this.modelForm.limitanteaportevolpension.toString() });

    this.model.doc.cuerpo.cc_id_297.push({ it: i, v: this.modelForm.limitanteVeinticincoexento.toString() });
    this.model.doc.cuerpo.cc_id_298.push({ it: i, v: this.modelForm.limitanteCesantiasexento.toString() });

    this.operacionCs280();
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_277.splice(index, 1);
    this.model.doc.cuerpo.cc_id_278.splice(index, 1);
    this.model.doc.cuerpo.cc_id_279.splice(index, 1);

    this.model.doc.cuerpo.cc_id_286.splice(index, 1); //Ingreso Laboral Promedio
    this.model.doc.cuerpo.cc_id_284.splice(index, 1); //Retención
    this.model.doc.cuerpo.cc_id_285.splice(index, 1); //Cesantías
    this.model.doc.cuerpo.cc_id_288.splice(index, 1); //Aporte a salud
    this.model.doc.cuerpo.cc_id_287.splice(index, 1); //Aporte obligatorio pensión
    this.model.doc.cuerpo.cc_id_291.splice(index, 1); //Aporte voluntario pensión
    this.model.doc.cuerpo.cc_id_290.splice(index, 1); //Aportes cuentas AFC O AVC
    this.model.doc.cuerpo.cc_id_292.splice(index, 1); //Apoyos económicos educativos
    this.model.doc.cuerpo.cc_id_289.splice(index, 1); //Cotizaciones voluntarias – RAIS

    this.model.doc.cuerpo.cc_id_294.splice(index, 1);
    this.model.doc.cuerpo.cc_id_295.splice(index, 1);
    this.model.doc.cuerpo.cc_id_296.splice(index, 1);
    this.model.doc.cuerpo.cc_id_297.splice(index, 1);
    this.model.doc.cuerpo.cc_id_298.splice(index, 1);


    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_277.length; i++) {
      this.model.doc.cuerpo.cc_id_277[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_278[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_279[i].it = i + 1;

      this.model.doc.cuerpo.cc_id_286[i].it = i + 1; //Ingreso Laboral Promedio
      this.model.doc.cuerpo.cc_id_284[i].it = i + 1; //Retención
      this.model.doc.cuerpo.cc_id_285[i].it = i + 1; //Cesantías
      this.model.doc.cuerpo.cc_id_288[i].it = i + 1; //Aporte a salud
      this.model.doc.cuerpo.cc_id_287[i].it = i + 1; //Aporte obligatorio pensión
      this.model.doc.cuerpo.cc_id_291[i].it = i + 1; //Aporte voluntario pensión
      this.model.doc.cuerpo.cc_id_290[i].it = i + 1; //Aportes cuentas AFC O AVC
      this.model.doc.cuerpo.cc_id_292[i].it = i + 1; //Apoyos económicos educativos
      this.model.doc.cuerpo.cc_id_289[i].it = i + 1; //Cotizaciones voluntarias – RAIS

      this.model.doc.cuerpo.cs_id_294[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_295[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_296[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_297[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_298[i].it = i + 1;

    }
    this.operacionCs280();
  }

  public validateFormCompleted(): boolean {
    return this.modelForm.pagador == undefined || this.modelForm.pagador == null || this.modelForm.pagador.trim() == "" ||
      this.modelForm.origen == undefined || this.modelForm.origen == null ||
      this.modelForm.valor == undefined || this.modelForm.valor == null || this.modelForm.valor == "0" ||
      this.modelForm.retencion == undefined || this.modelForm.retencion == null ||
      this.modelForm.cesantias == undefined || this.modelForm.cesantias == null ||
      this.modelForm.ingresolabprom == undefined || this.modelForm.ingresolabprom == null ||
      this.modelForm.aporteoblipension == undefined || this.modelForm.aporteoblipension == null ||
      this.modelForm.aportesalud == undefined || this.modelForm.aportesalud == null ||
      this.modelForm.cotizavolRAIS == undefined || this.modelForm.cotizavolRAIS == null ||
      this.modelForm.aportesAFCoAVC == undefined || this.modelForm.aportesAFCoAVC == null ||
      this.modelForm.aportevolpension == undefined || this.modelForm.aportevolpension == null ||
      this.modelForm.apoyoseconeduca == undefined || this.modelForm.apoyoseconeduca == null
  }


  public redondearFormData() {
    if (this.modelForm.valor) {
      this.modelForm.valor = this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(), true);
    } else { this.modelForm.valor = "0" }
  }

  public calcularValoresForm(conservarArt?: boolean) {
    this.operacionCs280();
    this.redondearFormData();
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();

      //Comportamiento especial por que son limitantes casillas compuestas pero que se tratan como simples al agregar solo en el item 0
      this.operacionesLimitantesComunesPorCasilla("0.30", "3800", "limitanteAFC");
      this.operacionesLimitantesComunesPorCasilla("0.25", "2500", "limitanteRAIS");
      this.operacionesLimitantesComunesPorCasilla("0.30", "3800", "limitanteaportevolpension");

      if (this.operacionTabla == this.OPERACION_EDITAR) {
        if (this.modelForm.origen == "0") {
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) { //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_277.length;
        //this.modelForm.pagador = "Contribuyente";
        this.modelForm.origen = "2";
        this.dataSourceBody.push(this.modelForm);
        // this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs280(true);
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs280();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];

    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }



  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }




  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
   // this.initializeTablaDesdeModelo();
  //  this.operacionCs280(true);
    this.dialogRef.close("");
  }
  public guardar() {

    this.calcularValoresForm();
    this.operacionCc297(true);
    this.operacionCc298(true);
    this.model.doc.cuerpo.cc_id_277 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionesLimitantesComunes();
    //this.operacionCc297() // se incluyo para rentas exentas
    // this.obtenerRestaCs711();
    //this.obtenerSumaCs290();
    this.operacionCs280(true);

    console.log("Casiila 290" + this.model.doc.cuerpo.cc_id_290)
    console.log("Casiila 294" + this.model.doc.cuerpo.cc_id_294)

    this.saveModel.emit(true);
    console.log("modelo ingresos" + this.model)
    this.closeModal();
  }
  public borrarTabla() {
    this.dataSourceBody = [];
  }

  private getValueCas(idCas: string) {
    let sum = "0";
    const dataCas = this.model.doc.cuerpo[idCas];
    if (dataCas && Array.isArray(dataCas) && dataCas.length) {
      for (const subItem of dataCas)
        sum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, subItem.v, sum);
    } else {
      if (dataCas && !Array.isArray(dataCas))
        return dataCas;
      return sum;
    }
    return sum;
  }

}






// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component.ts